import { render, staticRenderFns } from "./NavigationMenu.vue?vue&type=template&id=00022982&scoped=true&"
import script from "./NavigationMenu.vue?vue&type=script&lang=js&"
export * from "./NavigationMenu.vue?vue&type=script&lang=js&"
import style0 from "./NavigationMenu.vue?vue&type=style&index=0&id=00022982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00022982",
  null
  
)

export default component.exports